const xsrfToken = document.getElementById("csrf-token")
  ? document.getElementById("csrf-token").getAttribute("content")
  : "8e13d2c8-28c7-4a83-8bd6-186fb45543ad";

const apiConstants = {
  USER_URL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3001/user"
      : `/api/v1/user`,
  PERMISSIONS_URL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3001/permissions"
      : `/api/v1/user/permissions`,
  XSRF: xsrfToken,
  SESSION: "e2f452d1-3f4b-4416-a138-c217cb92c745",
};

export default apiConstants;
